// Hardcoded allow-list for the Admin Tools surface (sidenav entry +
// /settings/internal/admin-actions page). Only these accounts can see and run
// the destructive admin tools (run recovery, cache invalidation, migrations,
// billing rectification, dashboard users management, dev-license activation).
const ADMIN_ACTIONS_LOCAL_PARTS = [
  "luis",
  "goncalo",
  "andre",
  "jorge",
  "jose",
  "lourenco",
  "vicente",
  "david",
  "pedro",
  "daniel.anisoreac",
  "diogo",
  "gordan.allex",
  "hannah",
] as const;

const ADMIN_ACTIONS_DOMAINS = [
  "@noxus.ai",
  "@spot-technologies.com",
  "@minafter.com",
] as const;

const ADMIN_ACTIONS_ALLOWED_EMAILS: ReadonlySet<string> = new Set(
  ADMIN_ACTIONS_LOCAL_PARTS.flatMap((local) =>
    ADMIN_ACTIONS_DOMAINS.map((domain) => `${local}${domain}`)
  )
);

export function canAccessAdminActions(email: string | undefined): boolean {
  if (!email) return false;
  return ADMIN_ACTIONS_ALLOWED_EMAILS.has(email.toLowerCase());
}
